<div class="intervention-card" cdkScrollable>
    <h2 mat-dialog-title id="title">Intervention Details</h2>
    <mat-dialog-content>

    <div class="intervention-details">
        @for(item of data | keyvalue; track item) {
        <div class="intervention-row">
            <div class="key-column">
                <p class="key" id="{{item.key}}">{{ item.key }}</p>
            </div>
            <div class="value-column">
                <p class="value" id="{{item.key}}-value">{{ item.value || 'No data given'}}</p>
            </div>
        </div>
        }
    </div>
    </mat-dialog-content>
</div>
